import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const UploadsQueueActionTypes = {
  INITIALIZE_UPLOADING_QUEUE: 'uploadsQueue|initialize',
  FETCH_ATTACHMENTS_LIST: createSubtypes('buckets|fetchAttachmentsList'),
  DELETE_ATTACHMENT: createSubtypes('buckets|deleteAttachment'),
  ADD_UPLOADS_TO_THE_UPLOADING_QUEUE: 'uploadsQueue|addUploads',
  UPDATE_UPLOADS_BUCKET_NAME: 'uploadsQueue|updateUploadsBucketName',
  START_UPLOADING: 'uploadsQueue|startUploading',
  START_UPLOAD: createSubtypes('uploads|startUpload'),
  REMOVE_FROM_UPLOADING_QUEUE_BY_BUCKET_ID: 'uploadsQueue|removeByBucketId',
  CANCEL_ALL_UPLOADS: 'uploadsQueue|cancelAllUploads',
  CANCEL_UPLOAD: 'uploadsQueue|cancelUpload',
  CHANGE_UPLOAD_STATUS_TO_PENDING: 'uploadsQueue|uploading:pending',
  CHANGE_UPLOAD_STATUS_TO_IN_PROGRESS: 'uploadsQueue|uploading:inProgress',
  CHANGE_UPLOAD_STATUS_TO_SUCCEED: 'uploadsQueue|uploading:succeed',
  CHANGE_UPLOAD_STATUS_TO_CANCELED: 'uploadsQueue|uploading:canceled',
  CHANGE_UPLOAD_STATUS_TO_FAILED: 'uploadsQueue|uploading:failed',
  CLEAR_ATTACHMENTS_LIST: 'buckets|clearAttachmentsList',
};
